<template>
  <div class="m_bandeau">
    <div
      class="titre"
      v-html="$root.copy_content.title + $root.copy_content.subtitle"
    />
    <div class="mainText" v-html="$root.copy_content.description" />
    <button type="button" class="button-blue" @click="$emit('openAbout')">
      → à propos
    </button>
    <div class="m_bandeau--logo">
      <a
        v-for="logo in $root.copy_content.logos"
        :key="logo.metaFileName"
        :href="logo.caption"
        :is="logo.caption ? 'a' : 'span'"
        target="_blank"
      >
        <img
          :src="
            `${$root.dodoc_url}contenus-du-site-fabriqueedu/${logo.media_filename}`
          "
        />
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  watch: {},
  computed: {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.m_bandeau {
  // position: relative;
  max-width: 76vh;
  margin: 0 auto;

  @media screen and (min-width: 80rem) {
    .m_bandeau--logo {
      position: absolute;
      right: 0;
      top: 0;
      padding: var(--spacing);
      display: flex;
      flex-flow: column wrap;
    }
  }

  button {
    display: block;
    margin: calc(var(--spacing) * 2) auto;
  }
}

.m_bandeau--logo {
  text-align: center;
  margin-bottom: var(--spacing);

  img {
    width: 108px;
    height: 77px;
    margin: 0 auto;
    object-fit: contain;
  }
}
</style>
